import styled from 'styled-components/macro';

import { darken } from 'polished';
import { Link } from 'react-router-dom';

export const Wrapper = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  border-top: 4px solid #0bd6a7;
  background: #ffffff;
  height: 208px;
  color: #001247;
  padding: 49px 0 39px 0;

  @media screen and (max-width: 600px) {
    min-height: 240px;
    text-align: center;
    padding: 49px 30px 39px;
  }
`;

export const MainText = styled('h1')`
  margin: 0;
  font-size: 24px;
  font-weight: 700;
  line-height: 24px;
  margin-bottom: 10px;
`;

export const SubText = styled('h2')`
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
  margin-bottom: 22px;
`;

export const Button = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme }): string => theme.AccentGreen};
  color: white;
  width: 100%;
  cursor: pointer;
  min-height: 40px;
  width: 200px;
  font-family: Proxima Nova;
  font-size: 16px;
  font-weight: 600;
  line-height: 19px;

  &:hover {
    background: ${({ theme }): string => darken(0.05, theme.AccentGreen)};
  }

  &:focus,
  &:active {
    background: ${({ theme }): string => darken(0.1, theme.AccentGreen)};
  }
`;
